import { render, staticRenderFns } from "./addMultipleDocument.vue?vue&type=template&id=201465a6&scoped=true&"
import script from "./addMultipleDocument.vue?vue&type=script&lang=js&"
export * from "./addMultipleDocument.vue?vue&type=script&lang=js&"
import style0 from "./addMultipleDocument.vue?vue&type=style&index=0&id=201465a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201465a6",
  null
  
)

export default component.exports